'use client';

import * as React from 'react';
import { Card, CardContent, Divider, Theme, Typography } from '@mui/material';
import { Stack, SxProps } from '@mui/system';

interface SettingsSectionProps {
  title: string;
  content: React.ReactNode;
  popover?: string;
  language?: string;
  sx?: SxProps<Theme>;
  button?: React.ReactNode;
}

export function SettingsSection({ title, content }: SettingsSectionProps): React.JSX.Element {
  return (
    <Stack direction="column" gap={2}>
      <Card>
        <CardContent>
          <Typography variant="h6">{title}</Typography>
          <Divider sx={{ mt: 1 }} />
          <Stack direction="column" spacing={3} sx={{ mt: 2 }}>
            {content}
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
}
